import React from "react";
import {useRef} from "react";
import { Helmet } from "react-helmet-async";
import {useEffect} from "react";  
import "./App.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from "./components/Header";
import HeroBanner from "./components/HeroBanner";
import MenuSection from "./components/MenuSection";
import TruckDiaries from "./components/TruckDiaries";
// import LocationsSection from "./components/LocationsSection";
import OurStory from "./components/OurStory";
import ConnectedSection from "./components/ConnectedSection";
import Footer from "./components/Footer";
import ReviewsSection from "./components/ReviewsSection";

function App() {

  const aosInit = useRef(false);

  useEffect(() => {
    if (aosInit.current) return;

    AOS.init({
      duration: 1000,        // animation speed
      easing: "ease-in-out", // smooth easing
      once: false,           // trigger every time you scroll
      mirror: true,          // animate back out when scrolling up
      offset: 100,           // distance before triggering
    });

    aosInit.current = true;
  }, []);

  return (
    <>

    <Helmet>
  <title>Gourmet Delights | Fine Dining & Culinary Experience</title>
  <meta
    name="description"
    content="Savor exquisite dishes crafted by top chefs. Experience fine dining, fresh ingredients, and exceptional service at Gourmet Delights."
  />
  <link rel="canonical" href="https://websolutionusa.com/templates/restaurant/" />
  <meta property="og:title" content="Gourmet Delights | Fine Dining & Culinary Experience" />
  <meta
    property="og:description"
    content="Indulge in a world-class dining experience featuring gourmet cuisine, elegant ambiance, and impeccable hospitality."
  />
  <meta property="og:type" content="restaurant" />
  <meta property="og:url" content="https://websolutionusa.com/templates/restaurant/" />
  <meta property="og:image" content="https://websolutionusa.com/templates/restaurant/images/restaurant-og-image.jpg" />
</Helmet>
      <Header />
      <HeroBanner />
      <MenuSection />
      <TruckDiaries />
      {/* <LocationsSection /> */}
      <OurStory />
      <ReviewsSection />
      <ConnectedSection />
      <Footer />
    </>
  );
}

export default App;
